import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_partidas_contables} from '@/FirebaseConfig'
import {secondsToFullTimestamp, obtener_periodo, toNumber} from '@/Helper.js' 
export default {
    namespaced:true,
    state: {
        debe: '',
        haber: '',
        cantidad: 0,
        dialog: false,
    },
    actions: {
            add: async ({dispatch, state})=>{ 
                
               await dispatch('Movimientos_contables/regla_independiente', 
                {
                    valor: toNumber(state.cantidad),
                    reglas: [{porcentaje: 100,
                            debe: state.debe,
                            haber: state.haber}],
                    dato_1: '',
                    dato_2: '',
                    dato_3: 'Carga inicial',
                    dato_4: secondsToFullTimestamp(new Date()),
                    dato_5: obtener_periodo()
                }, {root: true})
                dispatch('cleanForm')
            },
            cleanForm: ({state})=>{
                state.cantidad = 0
                state.debe=''
                state.haber=''
                state.dialog = false
            }
        }
}


